import { API_BASE_URL } from '../utils/constants';

export async function fetchBlogs() {
  const res = await fetch(`${API_BASE_URL}/api/blogs`);
  if (!res.ok) throw new Error('Failed to fetch blogs');
  return res.json();
}

export async function createBlog(form, imageFile) {
  const formData = new FormData();
  formData.append('title', form.title);
  formData.append('date', form.date);
  formData.append('id', form.id);        // adjust if your field is "slug"
  formData.append('excerpt', form.excerpt);
  formData.append('content', form.content);

  if (imageFile) {
    formData.append('image', imageFile);
  }

  const res = await fetch(`${API_BASE_URL}/api/blogs`, {
    method: 'POST',
    body: formData,
    credentials: 'include',
  });

  if (!res.ok) throw new Error('Failed to create blog');
  return res.json();
}

export async function updateBlog(id, form, imageFile) {
  const formData = new FormData();
  formData.append('title', form.title);
  formData.append('date', form.date);
  formData.append('id', form.id);
  formData.append('excerpt', form.excerpt);
  formData.append('content', form.content);

  if (imageFile) {
    formData.append('image', imageFile);
  } else if (form.image) {
    formData.append('image', form.image);
  }

  const res = await fetch(`${API_BASE_URL}/api/blogs/${id}`, {
    method: 'PUT',
    body: formData,
    credentials: 'include',
  });

  if (!res.ok) throw new Error('Failed to update blog');
  const data = await res.json();
  return data.post || data;
}

export async function deleteBlog(id) {
  const res = await fetch(`${API_BASE_URL}/api/blogs/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok) throw new Error('Failed to delete blog');
  return res.json();
}

export const fetchBlogById = async (id) => {
  const res = await fetch(`${API_BASE_URL}/api/blogs/${id}`);
  if (!res.ok) throw new Error('Failed to fetch blog post');
  return res.json();
};